var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerPage',{staticClass:"EventNotFound"},[_c('LayoutFill',[_c('LayoutCenter',[_c('v-div',{attrs:{"display-1":"","pa-4":"","foreground-error":""}},[_c('span',[_vm._v("Sorry, the event you are looking for")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("cannot be found.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }